module.exports = __webpack_public_path__ + "img/2005-willhaben.dc447ca2.jpg";